import { motion, AnimatePresence } from "framer-motion";
import { Plane } from "lucide-react";

const W = 800, H = 400, PAD = 30;

export const FlightCanvas = ({ s, m, now }) => {
  const phase = s?.phase;
  const t = phase === "flying" || phase === "crashed" ? Math.max(0, (phase === "crashed" ? Math.log(s.crash) / s.growth : now - s.start_at)) : 0;
  const maxT = Math.max(8, t * 1.15);
  const maxM = Math.max(2, m * 1.2);
  const pt = (ti) => [PAD + (ti / maxT) * (W - 2 * PAD), H - PAD - ((Math.exp((s?.growth || 0.09) * ti) - 1) / (maxM - 1)) * (H - 2 * PAD)];
  const pts = Array.from({ length: 41 }, (_, i) => pt((t * i) / 40));
  const line = pts.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(" ");
  const [px, py] = pts[pts.length - 1];
  const [qx, qy] = pts[pts.length - 3] || [px - 1, py];
  const angle = (Math.atan2(py - qy, px - qx) * 180) / Math.PI;
  const left = Math.max(0, (s?.betting_ends || 0) - now);
  const crashed = phase === "crashed";

  return (
    <div className="relative rounded-2xl overflow-hidden bg-[#07070a] border border-white/10 aspect-[2/1]" data-testid="aviator-canvas">
      <div className="absolute inset-0 opacity-30" style={{ backgroundImage: "radial-gradient(circle at center, rgba(196,17,47,0.25), transparent 60%), repeating-linear-gradient(0deg, rgba(255,255,255,0.04) 0 1px, transparent 1px 50px), repeating-linear-gradient(90deg, rgba(255,255,255,0.04) 0 1px, transparent 1px 50px)" }} />
      <svg viewBox={`0 0 ${W} ${H}`} className="absolute inset-0 w-full h-full">
        <defs>
          <linearGradient id="avfill" x1="0" x2="0" y1="0" y2="1"><stop offset="0%" stopColor="#c4112f" stopOpacity="0.55" /><stop offset="100%" stopColor="#c4112f" stopOpacity="0" /></linearGradient>
        </defs>
        {phase !== "betting" && t > 0 && (
          <>
            <path d={`${line} L${px},${H - PAD} L${PAD},${H - PAD} Z`} fill="url(#avfill)" />
            <path d={line} stroke={crashed ? "#555" : "#ff2d55"} strokeWidth="5" fill="none" strokeLinecap="round" />
          </>
        )}
      </svg>
      {phase === "flying" && (
        <div className="absolute" style={{ left: `${(px / W) * 100}%`, top: `${(py / H) * 100}%`, transform: `translate(-30%,-70%) rotate(${angle}deg)` }}>
          <Plane size={44} className="text-[#ff2d55] fill-[#ff2d55] drop-shadow-[0_0_14px_#ff2d55]" style={{ transform: "rotate(45deg)" }} />
        </div>
      )}
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <AnimatePresence mode="wait">
          {phase === "betting" && (
            <motion.div key="bet" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0 }} className="text-center">
              <Plane size={56} className="mx-auto text-[#ff2d55] fill-[#ff2d55] animate-pulse" />
              <p className="font-display font-bold text-lg sm:text-2xl mt-3">Mərclər qəbul edilir</p>
              <div className="w-48 sm:w-64 h-1.5 bg-white/10 rounded-full mt-3 overflow-hidden mx-auto">
                <div className="h-full bg-[#ff2d55]" style={{ width: `${Math.min(100, (left / 7) * 100)}%` }} />
              </div>
              <p className="text-xs text-zinc-400 mt-2" data-testid="aviator-countdown">{left.toFixed(1)} san</p>
            </motion.div>
          )}
          {phase !== "betting" && (
            <motion.div key="mult" initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-center">
              {crashed && <p className="font-display font-bold text-red-500 text-lg sm:text-2xl uppercase tracking-[0.2em]">Uçdu!</p>}
              <p className={`font-display font-black text-5xl sm:text-8xl tracking-tighter ${crashed ? "text-red-500" : "text-white"}`} data-testid="aviator-multiplier">{m.toFixed(2)}x</p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};
